import React from "react";

const PageWithSidebarsFodbold = props => {
  let { isFodboldPage } = props;

  if (isFodboldPage) {
    return removeAds;
  } else {
    return null;
  }
};

export default PageWithSidebarsFodbold;


// WEBPACK FOOTER //
// ./src/component/NewsFeed/PageWithSidebarsFodbold.jsx